import {
  accessApiClientV1,
  apiClientV1,
  myjfrogBillingReferenceApi,
  myjfrogUsageApi,
  registrationServiceApi,
  userManagementApiClientV1,
} from '@fly/http-service';
import {
  BaseQueryFn,
  FetchBaseQueryError,
  createApi,
} from '@reduxjs/toolkit/query/react';
import { AxiosInstance, AxiosRequestConfig } from 'axios';

type Method = 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH';
type Query = {
  method: Method;
  url: string;
  data?: Record<any, any>;
  api?:
    | 'base'
    | 'access'
    | 'auth'
    | 'user'
    | 'billing_reference'
    | 'storedashboard'
    | 'usage';
  config?: AxiosRequestConfig;
};

const baseQuery: BaseQueryFn<
  Query,
  unknown,
  unknown,
  unknown,
  FetchBaseQueryError
> = async ({ url, method, data, api: apiType = 'base', config }, api) => {
  let axiosInstance: AxiosInstance;

  switch (apiType) {
    case 'user':
      axiosInstance = userManagementApiClientV1;
      break;
    case 'auth':
      axiosInstance = registrationServiceApi;
      break;
    case 'access':
      axiosInstance = accessApiClientV1;
      break;
    case 'billing_reference':
      axiosInstance = myjfrogBillingReferenceApi;
      break;
    case 'usage':
      axiosInstance = myjfrogUsageApi;
      break;
    case 'base':
      axiosInstance = apiClientV1;
      break;
    default:
      axiosInstance = apiClientV1;
  }

  const axiosMethod = method.toLowerCase() as Lowercase<Method>;

  try {
    if (axiosMethod === 'get') {
      const result = await axiosInstance[axiosMethod](url, config);
      return { data: result.data };
    }

    if (axiosMethod === 'delete') {
      const result = await axiosInstance[axiosMethod](url, { data, ...config });
      return { data: result.data };
    }

    const result = await axiosInstance[axiosMethod](url, data, {
      headers: config?.headers,
      ...config,
    });
    return { data: result.data };
  } catch (error) {
    return { error: error as FetchBaseQueryError };
  }
};

export const apiSlice = createApi({
  baseQuery,
  endpoints: () => ({}),
  tagTypes: [
    'access-tokens',
    'users',
    'profile',
    'payment',
    'slack-integrations',
    'chat-threads',
  ],
  reducerPath: 'api',
});
